export default __webpack_public_path__ + "23532def724d92bd167313a4fcba13df.png";